import React from 'react'

const TvIcon = () => {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 18 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path d='M7.37533 7.78123L12.3366 3.40623L13.1634 4.34377L8.20208 8.71877L7.37533 7.78123Z' fill='#575761' />
      <path d='M7.95693 3.72294L4.83192 6.53544L5.66813 7.46456L8.79313 4.65206L7.95693 3.72294Z' fill='#575761' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.875 0.125H17.125V11.375H15.3004L16.988 13.4846L16.0119 14.2654L13.6996 11.375H4.3004L1.98805 14.2654L1.01197 13.4846L2.69962 11.375H0.875V0.125ZM2.125 1.375V10.125H15.875V1.375H2.125Z'
        fill='#575761'
      />
    </svg>
  )
}

export default TvIcon
